import React, { Fragment } from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import styles from './styles.scss'
import { Flex } from 'reflexbox'
import { IconButton } from 'react-toolbox/lib/button'


const MoreInfo = ({
  text = "More info", 
  collapsed, 
  className, 
  action, 
  ...props
}) => {
  const icon = collapsed ? 'chevron_right' : 'expand_more'
  return(
    <Flex className={className} styleName='moreInfoButton'>
      <div onClick={action} styleName='moreInfoSection'>
        <IconButton styleName='moreInfoIcon' icon={icon} theme={styles}/>
        {text}
      </div>
    </Flex>
  )
}

export default CSSModules(styles)(MoreInfo)
